import successSoundYay from 'assets/sounds/success-yay.mp3';

class AudioManager {
    private successAudio: HTMLAudioElement | null = null;

    constructor() {
        this.preloadAudio();
    }

    private preloadAudio(): void {
        this.successAudio = new Audio(successSoundYay);
        this.successAudio.preload = 'auto';
        this.successAudio.load();
    }

    playSuccessSound(): void {
        const soundEnabled = localStorage.getItem('hustleSound') !== 'off';
        if (this.successAudio && soundEnabled) {
            this.successAudio.currentTime = 0;
            this.successAudio.play().catch((error) => {
                console.warn('Failed to play success sound:', error);
            });
        }
    }
}

export const audioManager = new AudioManager();